import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiServiceDelegate } from '../models/api-service-delegate';
import { AppCommon } from '../providers/app-common';
import { environment } from '../../environments/environment';

@Injectable()
export class ApiService {
  url = environment.api_url;

  constructor(private http: HttpClient) {}

  // Client-facing method
  callService(data: ApiServiceDelegate): void {
    const newURL = this.url + data.Action;
    this.execute(data.Data, newURL, data.Method).subscribe({
      next: (result: any) => data.Success(result.res),
      error: (error: any) => {
        if (error?.Errors) {
          data.Error(error.Errors);
        }
      },
    });
  }

  // execute(apiData: any, url: string, method: String): Observable<any> {
  //   const options = this.getHeaderOptions();

  //   switch (method.toUpperCase()) {
  //     case 'POST':
  //       return this.http.post(url, apiData, options).pipe(
  //         map((res) => ({ res })),
  //         catchError(this.errorHandler)
  //       );
  //     case 'DELETE':
  //       return this.http.delete(url, options).pipe(
  //         map((res) => ({ res })),
  //         catchError(this.errorHandler)
  //       );
  //     case 'PATCH':
  //       return this.http.patch(url, apiData, options).pipe(
  //         map((res) => ({ res })),
  //         catchError(this.errorHandler)
  //       );
  //     case 'PUT':
  //       return this.http.put(url, apiData, options).pipe(
  //         map((res) => ({ res })),
  //         catchError(this.errorHandler)
  //       );
  //     default:
  //       return this.http.get(url, options).pipe(
  //         map((res) => ({ res })),
  //         catchError(this.errorHandler)
  //       );
  //   }
  // }

  execute(apiData: any, url: string, method: String): Observable<any> {
  const isFormData = apiData instanceof FormData;
  const options = isFormData ? this.getHeaderOptionsForUpload() : this.getHeaderOptions();

  switch (method.toUpperCase()) {
    case 'POST':
      return this.http.post(url, apiData, options).pipe(
        map((res) => ({ res })),
        catchError(this.errorHandler)
      );
    case 'DELETE':
      return this.http.delete(url, options).pipe(
        map((res) => ({ res })),
        catchError(this.errorHandler)
      );
    case 'PATCH':
      return this.http.patch(url, apiData, options).pipe(
        map((res) => ({ res })),
        catchError(this.errorHandler)
      );
    case 'PUT':
      return this.http.put(url, apiData, options).pipe(
        map((res) => ({ res })),
        catchError(this.errorHandler)
      );
    default:
      return this.http.get(url, options).pipe(
        map((res) => ({ res })),
        catchError(this.errorHandler)
      );
  }
}


  getHeaderOptions(): { headers: HttpHeaders } {
    let httpHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const loggedObject: any = AppCommon.getloggedInObject();
    const token: string = loggedObject?.token;
    if (loggedObject && token) {
      httpHeaders = httpHeaders.set('Authorization', `Bearer ${token}`);
    }

    return { headers: httpHeaders };
  }

  getHeaderOptionsForUpload(): { headers: HttpHeaders } {
    let httpHeaders = new HttpHeaders();

    const loggedObject: any = AppCommon.getloggedInObject();
    const token: string = loggedObject?.token;
    if (loggedObject && token) {
      httpHeaders = httpHeaders.set('Authorization', `Bearer ${token}`);
    }

    return { headers: httpHeaders };
  }

  errorHandler(e: any) {
    return throwError(() => ({ Errors: e?.error || e }));
  }

  uploadFile(url: string, formData: FormData, headers: HttpHeaders): Observable<any> {
    const newURL = this.url + url;
    const httpOptions = { headers };

    return this.http.post(newURL, formData, httpOptions).pipe(
      map((res) => ({ res })),
      catchError(this.errorHandler)
    );
  }

uploadFileWithProgress(url: string, formData: FormData): Observable<any> {
    const newURL = this.url + url;;
    const headers = this.getHeaderOptionsForUpload().headers;

    const httpOptions = {
      headers,
      reportProgress: true, // Enable progress reporting
      observe:'events' as const, // Observe all events (progress, response, etc.)
    };

    return this.http.post(newURL, formData, httpOptions).pipe(
      map((event) => event),
      catchError(this.errorHandler)
    );
  }

  // Uncomment & adjust if needed for file downloads
  // downloadFile(url: string, headers: HttpHeaders): Observable<any> {
  //   const newURL = this.url + url;
  //   const httpOptions = {
  //     headers,
  //     observe: 'response' as 'body',
  //     responseType: 'blob' as 'json',
  //   };
  //   return this.http.get(newURL, httpOptions).pipe(
  //     map((res) => ({ res })),
  //     catchError(this.errorHandler)
  //   );
  // }

  // patchUploadFile, download, etc. can be added similarly
}
